
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {
  CustomsInfo,
  SalesContractOrInvoice,
  PackingListInfos,
  ElementsList, ProductInfos,
} from "@/model/FinancialBookingModels";
import {isEmpty, toUpper, cloneDeep} from "lodash";
import {
  customersDestinationCountry,
  getCustomsDetails,
  getSalesContractOrInvoice,
  getPackingListInfo,
  getDeclarationElements,
} from "@/api/booking-order";
import { INTERNATIONAL_TRADE_TERMS } from "@/constant";
import {deepClone} from "@/utils/deepClone";
import {formatJson} from "@/utils";
import {LoadingPlanType} from "@/views/sales-management/SalesBookingOrderManagement.vue";
import { Message } from "element-ui";
import Template from "@/views/system-management/template/index.vue";

/**
 * 报关单
 */
@Component({
  name: "AuditTable",
  components: {Template},
})
export default class extends Vue {
  @Prop({required: true}) private data: CustomsInfo;
  @Prop({required: true, default: ""}) private stage: string;
  @Prop({required: false, default: false}) private selectable: boolean;
  @Prop({required: false, default: false}) private show: boolean;
  private data_: CustomsInfo = new CustomsInfo();
  private deliveryConuntry: string;
  private invoiceSize: number;
  private packingListSize: number;
  @Watch("data", {deep: true, immediate: true})
  private watchData() {
    this.data_ = cloneDeep(this.data);
    if (!this.data_.customerProductInfoList) {
      return;
    }
    this.data_.customerProductInfoList.forEach((item, index) => {
      item.deliveryConuntry = this.data_.deliveryConuntry;
      item.index = index + 1;
      item.originCountry = "中国(142)";
      item.deliveryCountry = this.data_.deliveryConuntry;
      item.destinationCountry = this.data_.destinationCountry;
      item.unitPriceStr = `$${item.unitPrice}`;
      item.totalAmountStr = `$${item.totalAmount.toFixed(2)}`;
    });
  }

  @Watch("data_", {deep: true, immediate: true})
  private watchDeliveryConuntry() {
    if (!this.data_.customerProductInfoList) {
      return;
    }
    let currencyUnit: string;
    if(this.data_.currencyUnit === "USD") {
      currencyUnit = "$";
    }else if(this.data_.currencyUnit === "EURO") {
      currencyUnit = "€";
    }else {
      currencyUnit = "￥";
    }
    this.data_.customerProductInfoList.forEach((item, index) => {
      item.deliveryConuntry = this.data_.deliveryConuntry;
      item.index = index + 1;
      item.originCountry = "中国(142)";
      item.deliveryCountry = this.data_.deliveryConuntry;
      item.unitPriceStr = currencyUnit + item.unitPrice;
      item.totalAmountStr = currencyUnit + item.totalAmount.toFixed(2);
    });
  }

  private getinternationalTradeTerms(internationalTradeTerms: string) {
    return this.internationalTradeTermsOptions.filter(i => i.value === internationalTradeTerms)[0]?.label;
  }

  private showExtraDialog(rows) {
    this.$emit("showExtraDialog", rows);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private close() {
    this.$emit("update:show", false);
  }

  private confrim() {
    this.$emit("confrim", false);
  }

  private handleSelectionChange(rows) {
    this.$emit("selection", rows);
  }

  // 更新目的地
  private async changConuntry() {
    await customersDestinationCountry(this.data_.customerId, {
      deliveryCountry: this.data_.deliveryConuntry,
    });
    this.showCustomsDetails();
  }

  private async showCustomsDetails() {
    const data: any = await getCustomsDetails(this.data_.bookingOrderId);
    this.data_ = data;
  }

  // 申报要素
  private elementsList: ElementsList = new ElementsList();
  private  elementListSize = 0;
  private async geElementsList() {
    const data: any = await getDeclarationElements(this.data_.bookingOrderId);
    data.map((item, index) => {
      item.index = index + 1;
      this.elementListSize = this.elementListSize + 1;
    });
    this.elementsList = data;
  }

  // 查询销售合同或者发票
  private salesOrInvoiceData: SalesContractOrInvoice =
      new SalesContractOrInvoice();

  private async salesContractOrInvoiceData() {
    const data: any = await getSalesContractOrInvoice(
        this.data_.bookingOrderId
    );
    this.salesOrInvoiceData = data;
  }

  // 箱单
  private packingListData: PackingListInfos = new PackingListInfos();

  private async packingListInfo() {
    const data: any = await getPackingListInfo(this.data_.bookingOrderId);
    this.packingListData = data;
    // 处理样品中体积为空导致的右边框无效的问题
    this.packingListData.productInfoResponses.forEach((item) => {
      if (!item.totalVolumes) {
        item.totalVolumes = "";
      }
    })
  }

  private merges1 = [];
  private filterVal1 = [];
  private tableDatas1 = [];
  private multiHeader1 = [];
  private styles1 = [];

  // 发票
  private excelJson1() {
    const {
      invoiceCode,
      customerAddress,
      customerName,
      customerTel,
      invoiceDate,
      shippingMarks,
      totalAmount,
    } = this.salesOrInvoiceData;
    const t1 = this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?[
      "WENZHOU HUAQIANG AUTO PARTS CO.,LTD.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ]:[
      "WENZHOU JIARUI INDUSTRIAL CO.,LTD.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    // const t1 = [
    //   "WENZHOU HUAQIANG AUTO PARTS CO.,LTD.",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    // ];
    const t2 = [
      "NO. 40, LIMING INDUSTRIAL ZONE, LUCHENG DISTRICT, WENZHOU, CHINA",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const t4 = ["发    票", "", "", "", "", "", "", "", ""];
    const t5 = ["INVOICE", "", "", "", "", "", "", "", ""];
    const t6 = ["", "", "", "", "", "", "", "", ""];
    const t7 = ["TO:", "", "", "", "", "", "", "", ""];
    const t8 = [
      customerName,
      "",
      "",
      "",
      "",
      "",
      "",
      "Invoice No:",
      invoiceCode,
    ];
    const t9 = [
      customerAddress,
      "",
      "",
      "",
      "",
      "",
      "",
      "Date:",
      invoiceDate,
    ];
    const t10 = ["", "", "", "", "", "", "", "", ""];
    const t11 = [customerTel, "", "", "", "", "", "", "", ""];
    const t12 = ["", "", "", "", "", "", "", "", "", ""];
    const t14 = ["唛头", "", "品名", "", "", "数量/单位", "", "单价", "总金额"];
    const t15 = [
      "Marks & Number",
      "",
      "Descriptions",
      "",
      "",
      "Quantities",
      "",
      "Price",
      "Amount",
    ];
    const tradeTerms = this.getinternationalTradeTerms(this.data_.internationalTradeTerms);
    let port = "";
    if (tradeTerms === "FOB") {
      port = this.data_.departure;
    }
    if (tradeTerms === "CIF" || tradeTerms === "CNF") {
      port = this.data_.portDischarge;
    }
    const t16 = [
      shippingMarks,
      "",
      tradeTerms + "  " + port + "(" + this.data_.currencyUnit + ")",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    let items = [];
    let totalQuantity = 0;
    let productInfos = deepClone(this.salesOrInvoiceData.productInfos);
    let currencyUnit: string;
    if(this.salesOrInvoiceData.currencyUnit === "USD") {
      currencyUnit = "$";
    }else if(this.salesOrInvoiceData.currencyUnit === "EURO") {
      currencyUnit = "€";
    }else {
      currencyUnit = "￥";
    }
    productInfos.map((item) => {
      let itemTotalAmount = item.totalAmount.toFixed(2);
      items.push([
        "",
        "",
        item.englishProductName,
        "",
        "",
        item.quantity,
        item.unit,
       currencyUnit + item.unitPrice,
       currencyUnit + itemTotalAmount,
      ]);
      totalQuantity = item.quantity + totalQuantity;
    });
    this.filterVal1 = [];
    this.tableDatas1 = [];
    const t22 = ["TOTAL", "", "", "", "", totalQuantity, "", "", currencyUnit + totalAmount.toFixed(2)];
    this.multiHeader1 = [
      t1,
      t2,
      t4,
      t5,
      t7,
      t8,
      t9,
      t10,
      t11,
      t12,
      t6,
      t6,
      t14,
      t15,
      t16,
      ...items,
      t22,
      t6,
      t6,
      t6,
      t6,
      t6,
      t6,
      t6,
      t6,
      t6,
    ];
     this.invoiceSize = items.length;
    let tableMerges1 = [];
    for (let i = 0; i < this.invoiceSize; i++) {
      tableMerges1[i] = `C${17 + i}:E${17 + i}`;
    }
    this.merges1 = [
      "A1:I1",
      "A2:I2",
      "A3:I3",
      "A4:I4",
      "A5:I5",
      "A6:I6",
      "A7:E7",
      "A8:E9",
      "A10:E10",
      "A14:B14",
      "C14:E14",
      "A15:B15",
      "C15:E15",
      "F14:G14",
      "F15:G15",
      ...tableMerges1,
      `A16:B${16 + this.invoiceSize}`,
      `C16:I16`,
      // `B${17 + this.invoiceSize}:B${17 + this.invoiceSize}`,
      `A${18 + this.invoiceSize}:I${ 18 + this.invoiceSize + 8}`,
    ];
    for (let i = 0; i < this.invoiceSize; i++) {
      tableMerges1[i] = `C${17 + i}:E${17 + i}`;
    }
    this.styles1 = [
      {
        key: "A1",
        value: {
          font: {
            name: "楷体_GB2312",
            sz: 22,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A2",
        value: {
          font: {
            name: "Times New Roman",
            sz: 16,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A3",
        value: {
          font: {
            name: "Times New Roman",
            sz: 10,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A4",
        value: {
          font: {
            name: "楷体_GB2312",
            sz: 20,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
               vertical: "center",
          },
        },
      },
      {
        key: "A5",
        value: {
          font: {
            name: "Times New Roman",
            sz: 16,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
              vertical: "center",
          },
        },
      },
      {
        key: "A6",
        value: {
          font: {
            name: "Times New Roman",
            sz: 14,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A7",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
             horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A10",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A11",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A12",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A16",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            wrapText: true,
            horizontal: "left",
            vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            }
          }
        }
      },
      {
        key: "H7",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
             vertical: "center",
          },
        },
      },
      {
        key: "H8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
             vertical: "center",
          },
        },
      },
      {
        key: "A14",
        value: {
          font: {
            name: "宋体",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "B14",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: { style: "thin",
              color: {auto : 1}},
            right: { style: "thin",
              color: {auto : 1}}
          }
        },
      },
      {
        key: "C14",
        value: {
          font: {
            name: "宋体",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "D14",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            }
          }
        },
      },
      {
        key: "E14",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "F14",
        value: {
          font: {
            name: "宋体",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "G14",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "H14",
        value: {
          font: {
            name: "宋体",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "I14",
        value: {
          font: {
            name: "宋体",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "A15",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "B15",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "C15",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "D15",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            }
          }
        },
      },
      {
        key: "E15",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "F15",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "G15",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "H15",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "I15",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "C16",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "D16",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            }
          }
        },
      },
      {
        key: "E16",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            }
          }
        },
      },
      {
        key: "F16",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            }
          }
        },
      },
      {
        key: "G16",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            }
          }
        },
      },
      {
        key: "H16",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            }
          }
        },
      },
      {
        key: "I16",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      },
      {
        key: "B8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "B9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "C8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "C9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "D8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "D9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "E8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "E9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "I7",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "I8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      this.getInvoiceStyles()
    ];
  }

  private getInvoiceStyles() {
    let invoiceItem = [];
    const shippingMark1 ={
      key: 'A' + (16 + this.invoiceSize),
      value: {
        font: {
          name: "Times New Roman",
          sz: 12,
          color: {rgb: "#333333"},
          bold: false,
          italic: false,
          underline: false,
        },
        alignment: {
          horizontal: "center",
           vertical: "center",
        },
        border: {
          top: {style: "thin",
              color: {auto : 1}},
          bottom: {
            style: "thin",
                color: {auto : 1},
          },
          left: {
            style: "thin",
                color: {auto : 1}
          },
          right: {
            style: "thin",
                color: {auto : 1}
          }
        }
      },
    };
    const shippingMark2 ={
      key: 'B' + (16 + this.invoiceSize),
      value: {
        border: {
          top: {style: "thin",
            color: {auto : 1}},
          bottom: {
            style: "thin",
            color: {auto : 1},
          },
          left: {
            style: "thin",
            color: {auto : 1}
          },
          right: {
            style: "thin",
            color: {auto : 1}
          }
        }
      },
    };
    invoiceItem.push(shippingMark1,shippingMark2);
    const column = ['A','B','C','D','E','F','G','H','I'];
    for (let i = 0; i < column.length; i++) {
      for (let j = 0; j <= 9; j++) {
        const imageItemRow = {
          key: column[i] + (16 + this.invoiceSize + 2 + j),
          value: {
            border: {
              top: {style: "thin",
                color: {auto : 1}},
              bottom: {
                style: "thin",
                color: {auto : 1},
              },
              left: {
                style: "thin",
                color: {auto : 1}
              },
              right: {
                style: "thin",
                color: {auto : 1}
              }
            }
          },
        };
        invoiceItem.push(imageItemRow);
      }
      const totalRow ={
        key: column[i] + (16 + this.invoiceSize + 1),
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            bottom: {
              style: "thin",
              color: {auto : 1},
            },
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            }
          }
        },
      };
      invoiceItem.push(totalRow);
    }
    for (let i = 0; i < column.length; i++) {
      for (let j = 0; j < this.invoiceSize; j++) {
        if (column[i] === 'A'){
          const itemRow = {
            key: column[i] + (17 + j),
            value: {
              font: {
                name: "Times New Roman",
                sz: 12,
                color: {rgb: "#333333"},
                bold: false,
                italic: false,
                underline: false,
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
              },
              border: {
                left: {
                  style: "thin",
                  color: {auto : 1}
                }
              }
            },
          };
          invoiceItem.push(itemRow);
        }else if ( column[i] !== 'B'){
          const itemRow = {
            key: column[i] + (17 + j),
            value: {
              font: {
                name: "Times New Roman",
                sz: 12,
                color: {rgb: "#333333"},
                bold: false,
                italic: false,
                underline: false,
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
              },
              border: {
                top: {style: "thin",
                  color: {auto : 1}},
                bottom: {
                  style: "thin",
                  color: {auto : 1},
                },
                left: {
                  style: "thin",
                  color: {auto : 1}
                },
                right: {
                  style: "thin",
                  color: {auto : 1}
                }
              }
            },
          };
          invoiceItem.push(itemRow);
        }
      }
    }
    return  invoiceItem;
  }

  private styles2 = [];
  private merges2 = [];
  private filterVal2 = [];
  private tableDatas2 = [];
  private multiHeader2 = [];

  // 装箱单
  private excelJson2() {
    const {
      customerName,
      currentDate,
      bookingOrderCode,
      customerAddress,
      customerTel,
      shippingMarks,
      prompt,
      totalGrossWeight,
      totalNetWeight,
      totalVolume
    } = this.packingListData;
    const t1 = this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?["WENZHOU HUAQIANG AUTO PARTS CO.,LTD."]:["WENZHOU JIARUI INDUSTRIAL CO.,LTD."];
    // const t1 = ["WENZHOU HUAQIANG AUTO PARTS CO.,LTD."];
    const t2 = [
      "NO. 40, LIMING INDUSTRIAL ZONE, LUCHENG DISTRICT, WENZHOU, CHINA",
    ];
    const t4 = ["装箱单"];
    const t5 = ["PACKING   LIST"];
    const t6 = ["", "", "", "", "", "", "", "", "","","",""];
    const t7 = ["TO:"];
    const t8 = [
      customerName,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Packing List NO.:",
      bookingOrderCode,
    ];
    const t9 = [
      customerAddress,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Date:",
      currentDate,
    ];
    const t10 = [""];
    const t11 = [customerTel];
    const t12 = ["", "", "", "", "", "", "", "", "", ""];
    const t14 = [
      "Marks & Number",
      "",
      "Description of Goods",
      "",
      "",
      "QTY",
      "",
      "PACKAGES",
      "",
      "G.W.",
      "N.W.",
      "MEAS.",
    ];
    const t15 = ["", "", "", "", "", "", "", "", "", "KGS", "KGS", "CBM"];
    let items = [];
    let customsPackingQuanity = 0;
    let productQuantity = 0;
    let productInfos = deepClone(this.packingListData.productInfoResponses);
    let indexOfProdcutsWithMulityUnits = [];
    let counts = 0;
    productInfos.map((item) => {
      items.push([
        shippingMarks,
        "",
        item.englishProductName,
        "",
        "",
        item.quantity,
        item.unit,
        item.customsPackingQuantity,
        item.customsPackingType,
        item.totalGrossWeight,
        item.totalNetWeight,
        item.totalVolumes,
      ]);
      counts = counts + 1;
      customsPackingQuanity = item.customsPackingQuantity + customsPackingQuanity;
      productQuantity = item.quantity + productQuantity;
    });
    this.filterVal2 = [];
    this.tableDatas2 = [];
    const t22 = [
      "TOTAL",
      "",
      "",
      "",
      "",
      productQuantity,
      "",
      customsPackingQuanity,
      "",
      totalGrossWeight,
      totalNetWeight,
      totalVolume.toFixed(2),
    ];
    this.multiHeader2 = [
      t1,
      t2,
      t4,
      t5,
      t7,
      t8,
      t9,
      t10,
      t11,
      t12,
      t6,
      t6,
      t14,
      t15,
      ...items,
      t22,
      t6,
      t6,
      t6,
      t6,
      t6,
      t6,
      t6
    ];
     this.packingListSize = items.length;
    let tableMerges1 = [];
    for (let i = 0; i < this.packingListSize; i++) {
      tableMerges1[i] = `C${16 + i}:E${16 + i}`;
    }
    this.merges2 = [
      "A1:L1",
      "A2:L2",
      "A3:L3",
      "A4:L4",
      "A5:L5",
      "A6:L6",
      "A7:E7",
      "A8:E9",
      "A10:E10",
      "A14:B15",
      "C14:E15",
      "F14:G15",
      "H14:I15",
      ...tableMerges1,
      `A16:B${15 + this.packingListSize}`,
      `A${16 + this.packingListSize}:B${16 + this.packingListSize}`,
      `C${16 + this.packingListSize}:E${16 + this.packingListSize}`,
      `A${17 + this.packingListSize}:L${23 + this.packingListSize}`,
    ];
    this.styles2 = [
      {
        key: "A1",
        value: {
          font: {
            name: "楷体_GB2312",
            sz: 22,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A2",
        value: {
          font: {
            name: "Times New Roman",
            sz: 16,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A3",
        value: {
          font: {
            name: "Times New Roman",
            sz: 10,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A4",
        value: {
          font: {
            name: "楷体_GB2312",
            sz: 20,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A5",
        value: {
          font: {
            name: "Times New Roman",
            sz: 16,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",

          },
        },
      },
      {
        key: "A6",
        value: {
          font: {
            name: "Times New Roman",
            sz: 14,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A7",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",


          },
        },
      },
      {
        key: "A9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "B8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",


          },
        },
      },
      {
        key: "B9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "C8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",


          },
        },
      },
      {
        key: "C9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "D8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",


          },
        },
      },
      {
        key: "D9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "E8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",


          },
        },
      },
      {
        key: "E9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      {
        key: "A10",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A11",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A12",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "K7",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
             vertical: "center",
          },
        },
      },
      {
        key: "K8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
             vertical: "center",
          },
        },
      },
      {
        key: "L7",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
            vertical: "center",
          },
        },
      },
      {
        key: "L8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
            vertical: "center",
          },
        },
      },
      {
        key: "A14",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            left: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "A15",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "B14",
        value: {
          border: {
            top: {style: "thin",
              color: {auto : 1}},
            right: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "B15",
        value: {
          border: {
            right: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "C14",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "C15",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "D14",
        value: {
          border: {
            top: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "D15",
        value: {
          border: {
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "E14",
        value: {
          border: {
            top: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "E15",
        value: {
          border: {
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "F14",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "F15",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "G14",
        value: {
          border: {
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "G15",
        value: {
          border: {
            right: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "H14",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "H15",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "I14",
        value: {
          border: {
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "I15",
        value: {
          border: {
            right: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "J14",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "J15",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "K14",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "K15",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "L14",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "L15",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      this.getPackingListStyle(indexOfProdcutsWithMulityUnits)
    ];
  }

  private getPackingListStyle(indexOfProdcutsWithMulityUnits: any[]) {
    let packingListItem = [];
    const column = ['A','B','C','D','E','F','G','H','I','J','K','L'];
    for (let i = 0; i < column.length; i++) {
      for (let j = 0; j <= 10; j++) {
        const imageItemRow = {
          key: column[i] + (16 + this.packingListSize + 1 + j),
          value: {
            border: {
              top: {style: "thin",
                color: {auto : 1}},
              bottom: {
                style: "thin",
                color: {auto : 1},
              },
              left: {
                style: "thin",
                color: {auto : 1}
              },
              right: {
                style: "thin",
                color: {auto : 1}
              }
            }
          },
        };
        packingListItem.push(imageItemRow);
      }
      for (let j = 1; j <= this.packingListSize; j++) {
        let itemRow = null;
        if (indexOfProdcutsWithMulityUnits.indexOf(j) !== -1 && i === 6){
          itemRow  = {
            key: column[i] + (15  +  j),
            value: {
              font: {
                name: "Times New Roman",
                sz: 12,
                color: { rgb:"ff0000"},
                bold: false,
                italic: false,
                underline: false,
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
              },
              border: {
                top: {style: "thin",
                  color: {auto : 1}},
                bottom: {
                  style: "thin",
                  color: {auto : 1},
                },
                left: {
                  style: "thin",
                  color: {auto : 1}
                },
                right: {
                  style: "thin",
                  color: {auto : 1}
                }
              }
            },
          }
        }else{
          const key = column[i] + (15  +  j)
          itemRow  = {
            key: key,
            value: {
              font: {
                name: "Times New Roman",
                sz: 12,
                color: {rgb: "#333333"},
                bold: false,
                italic: false,
                underline: false,
              },
              alignment: {
                // 唛头需要换行
                wrapText: 'A16' == key,
                horizontal: "center",
                vertical: "center",
              },
              border: {
                top: {style: "thin",
                  color: {auto : 1}},
                bottom: {
                  style: "thin",
                  color: {auto : 1},
                },
                left: {
                  style: "thin",
                  color: {auto : 1}
                },
                right: {
                  style: "thin",
                  color: {auto : 1}
                }
              }
            },
          }
        }
        packingListItem.push(itemRow);
      }
      const totalRow = {
            key: column[i] + (16 + this.packingListSize),
            value: {
              font: {
                name: "Times New Roman",
                sz: 12,
                color: {rgb: "#333333"},
                bold: false,
                italic: false,
                underline: false,
              },
              alignment: {
                horizontal: "center",
                 vertical: "center",
              },
              border: {
                left: {
                  style: "thin",
                  color: {auto : 1}
                },
                right: {
                  style: "thin",
                  color: {auto : 1}
                },
                top: {
                  style: "thin",
                  color: {auto : 1}
                },
                bottom: {
                  style: "thin",
                  color: {auto : 1}
                },
              }
            },
          };
      packingListItem.push(totalRow);
    }
    return packingListItem
  }

  private styles3 = [];
  private merges3 = [];
  private filterVal3 = [];
  private tableDatas3 = [];
  private multiHeader3 = [];
  private saleContractSize: number;

  // 销售合同
  private excelJson3() {
    const {
      salesContractCode,
      customerAddress,
      customerName,
      customerTel,
      packing,
      partialShipmentsAndTransshipmentsAllowed,
      portOfDestination,
      portOfLoading,
      sailingSchedule,
      salesContractDate,
      shippingMarks,
      termOfPayment,
      totalAmount,
    } = this.salesOrInvoiceData;
    const t1 = this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?[
      "WENZHOU HUAQIANG AUTO PARTS CO.,LTD.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ]:[
      "WENZHOU JIARUI INDUSTRIAL CO.,LTD.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    // const t1 = [
    //   "WENZHOU HUAQIANG AUTO PARTS CO.,LTD.",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    // ];
    const t2 = [
      "NO. 40, LIMING INDUSTRIAL ZONE, LUCHENG DISTRICT, WENZHOU, CHINA",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const t3 = [
      "Tel:86-0577-86066082      Fax:86-0577-86066515",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const t4 = ["销 售 合 同", "", "", "", "", "", "", ""];
    const t5 = ["SALES CONTRACT", "", "", "", "", "", "", ""];
    const t6 = ["", "", "", "", "", "", "", ""];
    const t7 = ["BUYER:", "", "", "", "", "", "", ""];
    const t8 = [customerName, "", "", "", "", "", "S/C NO.:", salesContractCode];
    const t9 = [
      customerAddress,
      "",
      "",
      "",
      "",
      "",
      "PLACE:",
      "WENZHOU",
    ];
    const t10 = [
      "",
      "",
      "",
      "",
      "",
      "",
      "DATE:",
      salesContractDate,
    ];
    const t11 = [customerTel, "", "", "", "", "", "", ""];
    const t12 = ["", "", "", "", "", "", "", "", "", ""];
    const t16 = [
      "Name of Commodity and Specification",
      "",
      "",
      "",
      "Quantity",
      "",
      "Unit Price",
      "Amount",
    ];
    let items = [];
    let productInfos = deepClone(this.salesOrInvoiceData.productInfos);
    let currencyUnit: string;
    if(this.salesOrInvoiceData.currencyUnit === "USD") {
      currencyUnit = "$";
    }else if(this.salesOrInvoiceData.currencyUnit === "EURO") {
      currencyUnit = "€";
    }else {
      currencyUnit = "￥";
    }
    productInfos.map((item, index) => {
      let itemTotalAmount = item.totalAmount.toFixed(2);
      items.push([
        index + 1,
        item.englishProductName,
        "",
        "",
        item.quantity,
        item.unit,
        currencyUnit + item.unitPrice,
        currencyUnit + itemTotalAmount
      ]);
    });
    this.filterVal3 = [];
    this.tableDatas3 = [];
    const t23 = ["", "TOTAL", "", "", "", "", "", currencyUnit + totalAmount.toFixed(2)];
    const t24 = ["Quantity allowance ±", "", "", "", "", "", "", ""];
    const t25 = [
      "Time of Shipment",
      "",
      sailingSchedule,
      "",
      "",
      "",
      "",
      "",
    ];
    const t26 = [
      "Packing:",
      "",
      packing,
      "",
      "",
      "",
      "",
      "",
    ];
    const t27 = ["Shipping Marks:", "", shippingMarks, "", "", "", "", ""];
    const t28 = ["Port of Loading:", "", portOfLoading, "", "", "", "", ""];
    const t29 = ["Port of Destination:","", portOfDestination, "", "", "", "", "", ""];
    const t30 = [
      "Partial Shipments and Transhipments Allowed：" + partialShipmentsAndTransshipmentsAllowed,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const t31 = [
      "Term of Payment：" + termOfPayment,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const t32 = ["Insurance:", "", "", "", "", "", "", ""];
    const t33 = ["SELLERS:", "", "", "", "", "", "", ""];
    this.multiHeader3 = [
      t1,
      t2,
      t3,
      t4,
      t5,
      t6,
      t7,
      t8,
      t9,
      t10,
      t11,
      t12,
      t6,
      t6,
      t16,
      t6,
      ...items,
      t23,
      t24,
      t25,
      t26,
      t27,
      t28,
      t29,
      t30,
      t31,
      t32,
      t33,
      t6,
      t6,
      t6,
      t6,
    ];
     this.saleContractSize = items.length;
    let tableMerges1 = [];
    for (let i = 0; i < this.saleContractSize; i++) {
      tableMerges1[i] = `B${18 + i}:D${18 + i}`;
    }
    this.merges3 = [
      "A1:H1",
      "A2:H2",
      "A3:H3",
      "A4:H4",
      "A5:H5",
      "A6:H6",
      "A7:H7",
      "A8:B8",
      "A9:E9",
      "A10:E11",
      "A12:E12",
      "A16:D17",
      "E16:F17",
      "G16:G17",
      "H16:H17",
      ...tableMerges1,
      `B${18 + this.saleContractSize}:G${18 + this.saleContractSize}`,
      `A${19 + this.saleContractSize}:H${19 + this.saleContractSize}`,
      `A${20 + this.saleContractSize}:B${20 + this.saleContractSize}`,
      `C${20 + this.saleContractSize}:H${20 + this.saleContractSize}`,
      `A${21 + this.saleContractSize}:B${21 + this.saleContractSize}`,
      `C${21 + this.saleContractSize}:H${21 + this.saleContractSize}`,
      `A${22 + this.saleContractSize}:B${22 + this.saleContractSize}`,
      `C${22 + this.saleContractSize}:H${22 + this.saleContractSize}`,
      `A${23 + this.saleContractSize}:B${23 + this.saleContractSize}`,
      `C${23 + this.saleContractSize}:H${23 + this.saleContractSize}`,
      `A${24 + this.saleContractSize}:B${24 + this.saleContractSize}`,
      `C${24 + this.saleContractSize}:H${24 + this.saleContractSize}`,
      `A${25 + this.saleContractSize}:H${25 + this.saleContractSize}`,
      `A${26 + this.saleContractSize}:H${26 + this.saleContractSize}`,
      `A${27 + this.saleContractSize}:B${27 + this.saleContractSize}`,
      `C${27 + this.saleContractSize}:H${27 + this.saleContractSize}`,
      `A${28 + this.saleContractSize}:H${28 + this.saleContractSize}`,
      `A${29 + this.saleContractSize}:H${32 + this.saleContractSize}`,
    ];
    this.styles3 = [
      {
        key: "A1",
        value: {
          font: {
            name: "宋体",
            sz: 22,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A2",
        value: {
          font: {
            name: "Times New Roman",
            sz: 14,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A3",
        value: {
          font: {
            name: "Times New Roman",
            sz: 10,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A4",
        value: {
          font: {
            name: "Times New Roman",
            sz: 10,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A5",
        value: {
          font: {
            name: "宋体",
            sz: 22,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A6",
        value: {
          font: {
            name: "Times New Roman",
            sz: 18,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A8",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A10",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A11",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A12",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A13",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "G9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
             vertical: "center",
          },
        },
      },
      {
        key: "G10",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
             vertical: "center",
          },
        },
      },
      {
        key: "G11",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
             vertical: "center",
          },
        },
      },
      {
        key: "G12",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
             vertical: "center",
          },
        },
      },
      {
        key: "H9",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
            vertical: "center",
          },
        },
      },
      {
        key: "H10",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
            vertical: "center",
          },
        },
      },
      {
        key: "H11",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
            vertical: "center",
          },
        },
      },
      {
        key: "H12",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
          },
          alignment: {
            horizontal: "right",
            vertical: "center",
          },
        },
      },
      {
        key: "A16",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "A17",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "B16",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "B17",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "C16",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "C17",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "D16",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "D17",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "E16",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "E17",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "F16",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "F17",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "G16",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "G17",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "H16",
        value: {
          font: {
            name: "Times New Roman",
            sz: 12,
            color: {rgb: "#333333"},
            bold: false,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
      {
        key: "H17",
        value: {
          border: {
            left: {
              style: "thin",
              color: {auto : 1}
            },
            right: {
              style: "thin",
              color: {auto : 1}
            },
            top: {
              style: "thin",
              color: {auto : 1}
            },
            bottom: {
              style: "thin",
              color: {auto : 1}
            },
          }
        },
      },
        this.getSalesContractStyle()
    ];
  }

  private getSalesContractStyle() {
      let saleContractItem = [];
      const column = ['A','B','C','D','E','F','G','H'];
      for (let i = 0; i < column.length; i++) {
        for (let j = 3; j <= 15; j++) {
          if (j > 11){ // 图片位置
            const imageRow = {
              key: column[i] + (17 + this.saleContractSize  + j),
              value: {
                border: {
                  bottom: {
                    style: "thin",
                    color: {auto: 1},
                  },
                  left: {
                    style: "thin",
                    color: {auto: 1}
                  },
                  right: {
                    style: "thin",
                    color: {auto: 1}
                  }
                }
              },
            };
            saleContractItem.push(imageRow);
          }
          if (j === 3){
            if (column[i] === 'A' || column[i] === 'H'){
              const timeOfShipmentRow = {
                key: column[i] + (17 + this.saleContractSize  + j),
                value: {
                  border: {
                    top: {
                      style: "thin",
                      color: {auto: 1}
                    },
                    left: {
                      style: "thin",
                      color: {auto: 1}
                    },
                    right: {
                      style: "thin",
                      color: {auto: 1}
                    }
                  }
                },
              };
              saleContractItem.push(timeOfShipmentRow);
            }else{
                const timeOfShipmentRowWithOtherColumn = {
                  key: column[i] + (17 + this.saleContractSize + j),
                  value: {
                    font: {
                      name: "Times New Roman",
                      sz: 12,
                      color: {rgb: "#333333"},
                      bold: false,
                      italic: false,
                      underline: false,
                    },
                    alignment: {
                      horizontal: "left",
                      vertical: "center",
                    },
                    border: {
                      top: {
                        style: "thin",
                        color: {auto: 1}
                      }
                    }
                  },
                };
                saleContractItem.push(timeOfShipmentRowWithOtherColumn);
            }
          }
          if (j > 3 && j < 12) {
            if (column[i] === 'A'){
              const otherRow = {
                key: column[i] + (17 + this.saleContractSize + j),
                value: {
                  font: {
                    name: "Times New Roman",
                    sz: 12,
                    color: {rgb: "#333333"},
                    bold: false,
                    italic: false,
                    underline: false,
                  },
                  alignment: {
                    horizontal: "left",
                     vertical: "center",
                  },
                  border: {
                    left: {
                      style: "thin",
                      color: {auto: 1}
                    }
                  }
                },
              };
              saleContractItem.push(otherRow);
            }
           else if (column[i] === 'H'){
              const otherRow = {
                key: column[i] + (17 + this.saleContractSize + j),
                value: {
                  border: {
                    right: {
                      style: "thin",
                      color: {auto: 1}
                    }
                  }
                },
              };
              saleContractItem.push(otherRow);
            }
           else{
              const key = column[i] + (17 + this.saleContractSize + j)
              const otherRow = {
                key: key,
                value: {
                  font: {
                    name: "Times New Roman",
                    sz: 12,
                    color: {rgb: "#333333"},
                    bold: false,
                    italic: false,
                    underline: false,
                  },
                  alignment: {
                    // 唛头处理
                    wrapText: `C${22+this.saleContractSize}` == key,
                    horizontal: "left",
                     vertical: "center",
                  },
                },
              };
              saleContractItem.push(otherRow);
            }
          }
        }
        for (let j = 1; j <= this.saleContractSize + 1; j++) {
          const itemAndTotalRow = {
            key: column[i] + (17 + j),
            value: {
              font: {
                name: "Times New Roman",
                sz: 12,
                color: {rgb: "#333333"},
                bold: false,
                italic: false,
                underline: false,
              },
              alignment: {
                horizontal: "center",
                 vertical: "center",
              },
              border: {
                top: {style: "thin",
                  color: {auto : 1}},
                bottom: {
                  style: "thin",
                  color: {auto : 1},
                },
                left: {
                  style: "thin",
                  color: {auto : 1}
                },
                right: {
                  style: "thin",
                  color: {auto : 1}
                }
              }
            },
          };
          saleContractItem.push(itemAndTotalRow);
        }
        const key = column[i] + (17 + this.saleContractSize + 2)
        const quantityAllowanceRow = {
          key: key,
          value: {
            font: {
              name: "Times New Roman",
              sz: 12,
              color: {rgb: "#333333"},
              bold: false,
              italic: false,
              underline: false,
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
            },
            border: {
              top: {
                style: "thin",
                color: {auto: 1}
              },
              bottom: {
                style: "thin",
                color: {auto: 1},
              },
              left: {
                style: "thin",
                color: {auto: 1}
              },
              right: {
                style: "thin",
                color: {auto: 1}
              }
            }
          },
        };
        saleContractItem.push(quantityAllowanceRow);
      }
      return saleContractItem
  }

  private styles4 = [];
  private merges4 = [];
  private filterVal4 = [];
  private tableDatas4 = [];
  private multiHeader4 = [];
  private customsDeclarationSize:number;

  // 报关单
  private excelJson4() {
    const {
      freightAmount,
      insuranceAmount,
      extrasAmount,
      totalNumberPcs,
      grossWeight,
      netWeight,
      internationalTradeTerms,
      packingType,
      tradeCountry,
      deliveryConuntry,
      bookingOrderCode,
      portDischarge,
      factoryName,
      customerName,
      shippingMark,
      departure,
      transportation,
      addressRemark
    } = this.data_;
    const t1 = [
      "",
      "中华人民共和国海关出口货物报关单（最新版）",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const t2 = ["", "", "", "", "", "", "", "", "", "", "", "", ""];
    const t3 = [
      "预录入编号：",
      "",
      "",
      "海关编号：",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "页码/页数：",
    ];
    const t4 = [
      "境内发货人：",
      "",
      "",
      "出境关别：",
      "",
      "出口日期",
      "",
      "",
      "",
      "",
      "申报日期",
      "备案号",
      "",
    ];
    const t5 = this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?
    ["温州华强汽配有限公司(3303961545) \n" +
    "AEOCN777238819\n" +
    "91330302777238819A", "", "", departure, "", "", "", "", "", "", "", "", ""]
    :["温州嘉锐实业有限公司(3303960A6A) \n" +
    "91330302MA285RGA2B", "", "", departure, "", "", "", "", "", "", "", "", ""];
    // const t5 = ["温州华强汽配有限公司(3303961545) \n" +
    // "AEOCN3303961545\n" +
    // "91330302777238819A", "", "", departure, "", "", "", "", "", "", "", "", ""];
    const t6 = [
      "境外收货人：",
      "",
      "",
      "运输方式：",
      "",
      "运输工具名称及航次号",
      "",
      "",
      "",
      "",
      "提运单号",
      "",
      "",
    ];
    const t7 = [customerName, "", "", transportation, "", "", "", "", "", "", "", "", ""];
    const t8 = [
      "生产销售单位：",
      "",
      "",
      "监管方式：",
      "",
      "征免性质",
      "",
      "",
      "",
      "",
      "许可证号",
      "",
      "",
    ];
    const t9 = this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?
    [
      "温州华强汽配有限公司",
      "",
      "",
      "一般贸易",
      "",
      "一般征税",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ]
    :[
      "温州嘉锐实业有限公司",
      "",
      "",
      "一般贸易",
      "",
      "一般征税",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    // const t9 = [
    //   "温州华强汽配有限公司",
    //   "",
    //   "",
    //   "一般贸易",
    //   "",
    //   "一般征税",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    // ];
    const t10 = [
      "合同协议号",
      "",
      "",
      "贸易国（地区）",
      "",
      "运抵国（地区）",
      "",
      "",
      "",
      "",
      "指运港",
      "离境口岸",
      "",
    ];
    const t11 = [
      bookingOrderCode,
      "",
      "",
      tradeCountry,
      "",
      deliveryConuntry,
      "",
      "",
      "",
      "",
      portDischarge,
      "",
      "",
    ];
    const t12 = [
      "包装种类",
      "",
      "",
      "件数",
      "毛重（千克）",
      "净重（千克）",
      "",
      "",
      "成交方式",
      "",
      "运费",
      "保费",
      "杂费",
    ];
    const t13 = [
      packingType,
      "",
      "",
      totalNumberPcs,
      Number(grossWeight.toFixed()),
      Number(netWeight.toFixed()),
      "",
      "",
      this.getinternationalTradeTerms(internationalTradeTerms),
      "",
      freightAmount,
      insuranceAmount,
      extrasAmount,
    ];
    const t14 = [
      "随附单证及编号",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const t15 = ["", "", "", "", "", "", "", "", "", "", "", "", ""];
    // 标记唛码及备注中加入产品其他的货源地
    let remark = shippingMark;
    if (addressRemark !== null) {
      remark = remark + "\n" + addressRemark;
    }
    // 备注超出255个字符要提示字符数
    let title = "标记唛码及备注";
    if (remark.length > 255) {
      title = title + "  (" + remark.length + "个字符,最多允许255个字符)";
    }
    const t16 = [
      title,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const t17 = ["", "", "", "", "", "", "", "", "", "", "", "", ""];
    const t18 = [remark, "", "", "", "", "", "", "", "", "", "", "", "",];
    // 标记唛码及备注的自动撑开处理，备注默认三行的合并单元格，根据字体与一行高度的比例计算出要新增的行数
    let lines = Math.ceil((remark.split(/\n/).length) * 0.8) - 2;
    if (lines < 0) {
      lines = 0
    }
    const emptyLine = [];
    for (let i = 0; i < lines; i++) {
      emptyLine.push(["", "", "", "", "", "", "", "", "", "", "", "", ""]);
    }
    const t19 = ["", "", "", "", "", "", "", "", "", "", "", "", ""];
    const t20 = ["", "", "", "", "", "", "", "", "", "", "", "", ""];
    const t21 = ["", "", "", "", "", "", "", "", "", "", "", "", ""];
    const t22 = [
      "项号",
      "商品编号",
      "商品名称及规格型号",
      "",
      "",
      "数量",
      "单位",
      "单价",
      "总价",
      "原产国（地区）",
      "最终目的国（地区）",
      "境内货源地",
      "征免",
    ];
    this.filterVal4 = [
      "index",
      "hsCode",
      "declarationDescription",
      "data1",
      "data2",
      "totalNumberPcs",
      "firstUnit",
      "unitPriceStr",
      "totalAmountStr",
      "originCountry",
      "deliveryCountry",
      "productAddress",
      "exemption",
    ];
    let tableFooter = [
      {
        index: "特殊关系确认：",
        hsCode: "",
        declarationDescription: "否",
        data1: "价格影响确认：",
        data2: "否",
        totalNumberPcs: "支付特许权使用费确认：",
        firstUnit: "",
        unitPriceStr: "",
        totalAmountStr: "否",
        originCountry: "",
        deliveryCountry: "自报自缴：",
        productAddress: "否",
        exemption: "",
      },
      {
        index: "申报人员",
        hsCode: "",
        declarationDescription: "申报人员证号",
        data1: "电话",
        data2: "否",
        totalNumberPcs: "兹申明对以上内容承担如实申报、依法纳税之法律责任",
        firstUnit: "",
        unitPriceStr: "",
        totalAmountStr: "",
        originCountry: "",
        deliveryCountry: "海关批注及签章",
        productAddress: "",
        exemption: "",
      },
      {
        index: "",
        hsCode: "",
        declarationDescription: "",
        data1: "",
        data2: "",
        totalNumberPcs: "",
        firstUnit: "",
        unitPriceStr: "",
        totalAmountStr: "",
        originCountry: "",
        deliveryCountry: "",
        productAddress: "",
        exemption: "",
      },
      {
        index: "申报单位",
        hsCode: "",
        declarationDescription: "",
        data1: "",
        data2: "",
        totalNumberPcs: "",
        firstUnit: "申报单位（签章）",
        unitPriceStr: "",
        totalAmountStr: "",
        originCountry: "",
        deliveryCountry: "",
        productAddress: "",
        exemption: "",
      },
    ];
    let productInfos = [];
    this.data_.customerProductInfoList.map(value => {
        productInfos.push({
          index: value.index,
          hsCode:value.hsCode,
          declarationDescription: value.declarationDescription,
          data1: "",
          data2: "",
          totalNumberPcs: value.totalNumberPcs,
          firstUnit: value.firstUnit,
          unitPriceStr: value.unitPriceStr,
          totalAmountStr: value.totalAmountStr,
          originCountry: value.originCountry,
          deliveryCountry: value.destinationCountry,
          productAddress: value.productAddress,
          exemption: value.exemption
        })
      })
    this.tableDatas4 = [...productInfos, ...tableFooter];
     this.customsDeclarationSize = this.data_.customerProductInfoList.length;
    let tableMerges1 = [];
    for (let i = 0; i < this.customsDeclarationSize; i++) {
      tableMerges1[i] = `C${24 + lines + i}:E${24 + lines + i}`;
    }
    let tableMerges2 = [];
    for (let i = 0; i < this.customsDeclarationSize; i++) {
      tableMerges2[i] = `H${24 + lines + i}:I${24 + lines + i}`;
    }
    this.merges4 = [
      "B2:M2",
      "A1:A3",
      "A4:B4",
      "A5:B5",
      "D5:E5",
      "F5:J5",
      "L5:M5",
      "A6:C6",
      "D6:E6",
      "F6:J6",
      "L6:M6",
      "A7:B7",
      "D7:E7",
      "F7:J7",
      "K7:M7",
      "A8:C8",
      "D8:E8",
      "F8:J8",
      "K8:M8",
      "A9:B9",
      "D9:E9",
      "F9:J9",
      "K9:M9",
      "A10:C10",
      "D10:E10",
      "F10:J10",
      "K10:M10",
      "A11:C11",
      "D11:E11",
      "F11:J11",
      "L11:M11",
      "A12:C12",
      "D12:E12",
      "F12:J12",
      "L12:M12",
      "A13:C13",
      "F13:H13",
      "I13:J13",
      "A14:C14",
      "F14:H14",
      "I14:J14",
      "A15:M15",
      "A16:M16",
      "A17:M17",
      "A18:M18",
      `A19:M${21 + lines}`,
      `C${23 + lines}:E${23 + lines}`,
      ...tableMerges1,
      `A${24 + lines + this.customsDeclarationSize}:B${24 + lines + this.customsDeclarationSize}`,
      `F${24 + lines + this.customsDeclarationSize}:H${24 + lines + this.customsDeclarationSize}`,
      `L${24 + lines + this.customsDeclarationSize}:M${24 + lines + this.customsDeclarationSize}`,
      // `H${24 + this.customsDeclarationSize}:M${24 + this.customsDeclarationSize}`,
      `A${25 + lines + this.customsDeclarationSize}:B${25 + lines + this.customsDeclarationSize}`,
      `F${25 + lines + this.customsDeclarationSize}:J${25 + lines + this.customsDeclarationSize}`,
      `K${25 + lines + this.customsDeclarationSize}:M${27 + lines + this.customsDeclarationSize}`,
      `A${27 + lines + this.customsDeclarationSize}:B${27 + lines + this.customsDeclarationSize}`,
      `G${27 + lines + this.customsDeclarationSize}:H${27 + lines + this.customsDeclarationSize}`,
    ];
    this.multiHeader4 = [
      t1,
      t2,
      t3,
      t4,
      t5,
      t6,
      t7,
      t8,
      t9,
      t10,
      t11,
      t12,
      t13,
      t14,
      t15,
      t16,
      t17,
      t18,
      ...emptyLine,
      t19,
      t20,
      t21,
      t22,
    ];
    const commonStyle = {
      font: {
        name: "微软雅黑",
        sz: 9,
        color: {rgb: "#333333"},
        bold: true,
        italic: false,
        underline: false,
      },
      alignment: {
        horizontal: "left",
         vertical: "center",
      },
    };
    const centerStyle = {
      font: {
        name: "微软雅黑",
        sz: 9,
        color: {rgb: "#333333"},
        bold: true,
        italic: false,
        underline: false,
      },
      alignment: {
        horizontal: "center",
         vertical: "center",
      },
    };
    const letter = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
    ];
    let list = [];
    for (let y = 0; y < letter.length; y++) {
      for (let i = 0; i < 18; i++) {
        list.push({
          key: `${letter[y]}${i + 1}`,
          value: commonStyle,
        });
      }
    }
    let list2 = [];
    for (let y2 = 0; y2 < letter.length; y2++) {
      for (let i = 23 + lines + this.customsDeclarationSize; i < 28 + lines + this.customsDeclarationSize; i++) {
        list2.push({
          key: `${letter[y2]}${i + 1}`,
          value: commonStyle,
        });
      }
    }
    let tableList = [];
    for (let y3 = 0; y3 < letter.length; y3++) {
      for (let i = 23 + lines; i < 24 + lines + this.customsDeclarationSize; i++) {
        tableList.push({
          key: `${letter[y3]}${i}`,
          value: centerStyle,
        });
      }
    }
    this.styles4 = [
      ...list,
      ...list2,
      {
        key: "B2",
        value: {
          font: {
            name: "微软雅黑",
            sz: 14,
            color: {rgb: "#333333"},
            bold: true,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A12",
        value: {
          font: {
            name: "微软雅黑",
            sz: 9,
            color: {rgb: "#333333"},
            bold: true,
            italic: false,
            underline: false,
          },
          fill: {
            fgColor: {rgb: "92d050"},
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "A14",
        value: {
          font: {
            name: "微软雅黑",
            sz: 9,
            color: {rgb: "#333333"},
            bold: true,
            italic: false,
            underline: false,
          },
          fill: {
            fgColor: {rgb: "92d050"},
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "D14",
        value: {
          font: {
            name: "微软雅黑",
            sz: 9,
            color: {rgb: "#333333"},
            bold: true,
            italic: false,
            underline: false,
          },
          fill: {
            fgColor: {rgb: "92d050"},
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "E14",
        value: {
          font: {
            name: "微软雅黑",
            sz: 9,
            color: {rgb: "#333333"},
            bold: true,
            italic: false,
            underline: false,
          },
          fill: {
            fgColor: {rgb: "92d050"},
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "F14",
        value: {
          font: {
            name: "微软雅黑",
            sz: 9,
            color: {rgb: "#333333"},
            bold: true,
            italic: false,
            underline: false,
          },
          fill: {
            fgColor: {rgb: "92d050"},
          },
          alignment: {
            horizontal: "left",
             vertical: "center",
          },
        },
      },
      {
        key: "G23",
        value: {
          font: {
            name: "微软雅黑",
            sz: 9,
            color: {rgb: "#ed3f24"},
            bold: true,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "center",
             vertical: "center",
          },
        },
      },
      {
        key: "A19",
        value: {
          font: {
            name: "微软雅黑",
            sz: 9,
            color: {rgb: "#333333"},
            bold: true,
            italic: false,
            underline: false,
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
          },
        },
      },
      ...tableList,
      this.getCustomsDeclarationFormStyles(lines)
    ];
  }

  private getCustomsDeclarationFormStyles(lines) {
    this.getElementListStyles();
    const customsDeclarationFormItem = [];
    const column = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M'];
    for (let i = 0; i < column.length; i++) {
      for (let j = 0; j < 12; j++) {
        if (j === 0 || j == 2 || j == 4 || j == 6 || j == 8 || j == 10) {
          if (column[i] === 'A' || column[i] === 'D' || column[i] === 'F' || column[i] === 'K' || column[i] === 'L') {
            const topRow = {
              key: column[i] + (5 + j),
              value: {
                font: {
                  name: "微软雅黑",
                  sz: 9,
                  color: {rgb: "#333333"},
                  bold: true,
                  italic: false,
                  underline: false,
                },
                alignment: {
                  horizontal: "left",
                   vertical: "center",
                },
                border: {
                  top: {
                    style: "thin",
                    color: {auto: 1}
                  },
                  left: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          } else if (column[i] === 'M') {
            const topRow = {
              key: column[i] + (5 + j),
              value: {
                font: {
                  name: "微软雅黑",
                  sz: 9,
                  color: {rgb: "#333333"},
                  bold: true,
                  italic: false,
                  underline: false,
                },
                alignment: {
                  horizontal: "left",
                   vertical: "center",
                },
                border: {
                  top: {
                    style: "thin",
                    color: {auto: 1}
                  },
                  right: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          } else {
            const topRow = {
              key: column[i] + (5 + j),
              value: {
                font: {
                  name: "微软雅黑",
                  sz: 9,
                  color: {rgb: "#333333"},
                  bold: true,
                  italic: false,
                  underline: false,
                },
                alignment: {
                  horizontal: "left",
                   vertical: "center",
                },
                border: {
                  top: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          }
        } else {
          if (column[i] === 'A' || column[i] === 'D' || column[i] === 'F' || column[i] === 'K' || column[i] === 'L') {
            const topRow = {
              key: column[i] + (5 + j),
              value: {
                font: {
                  name: "微软雅黑",
                  sz: 9,
                  color: {rgb: "#333333"},
                  bold: true,
                  italic: false,
                  underline: false,
                },
                alignment: {
                  horizontal: "left",
                   vertical: "center",
                },
                border: {
                  bottom: {
                    style: "thin",
                    color: {auto: 1}
                  },
                  left: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          }
          else if (column[i] === 'M') {
            if (j == 11) {
              const topRow = {
                key: column[i] + (5 + j),
                value: {
                  font: {
                    name: "微软雅黑",
                    sz: 9,
                    color: {rgb: "#333333"},
                    bold: true,
                    italic: false,
                    underline: false,
                  },
                  alignment: {
                    horizontal: "left",
                     vertical: "center",
                  },
                  border: {
                    right: {
                      style: "thin",
                      color: {auto: 1}
                    },
                    bottom: {
                      style: "thin",
                      color: {auto: 1}
                    },
                  }
                },
              };
              customsDeclarationFormItem.push(topRow);
            } else {
              const topRow = {
                key: column[i] + (5 + j),
                value: {
                  font: {
                    name: "微软雅黑",
                    sz: 9,
                    color: {rgb: "#333333"},
                    bold: true,
                    italic: false,
                    underline: false,
                  },
                  alignment: {
                    horizontal: "left",
                     vertical: "center",
                  },
                  border: {
                    right: {
                      style: "thin",
                      color: {auto: 1}
                    },
                  }
                },
              };
              customsDeclarationFormItem.push(topRow);
            }
          } else {
            const bottomRow = {
              key: column[i] + (5 + j),
              value: {
                font: {
                  name: "微软雅黑",
                  sz: 9,
                  color: {rgb: "#333333"},
                  bold: true,
                  italic: false,
                  underline: false,
                },
                alignment: {
                  horizontal: "left",
                   vertical: "center",
                },
                border: {
                  bottom: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(bottomRow);
          }
        }
      }

      for (let j = 17; j < 23 + lines; j++) {
        if (j === 17) {
          if (column[i] === 'A' || column[i] === 'M') {
            const topRow = {
              key: column[i] + j,
              value: {
                font: {
                  name: "微软雅黑",
                  sz: 9,
                  color: {rgb: "#333333"},
                  bold: true,
                  italic: false,
                  underline: false,
                },
                alignment: {
                  horizontal: "left",
                   vertical: "center",
                },
                border: {
                  top: {
                    style: "thin",
                    color: {auto: 1}
                  },
                  left: {
                    style: "thin",
                    color: {auto: 1}
                  },
                  right: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          } else {
            const topRow = {
              key: column[i] + j,
              value: {
                font: {
                  name: "微软雅黑",
                  sz: 9,
                  color: {rgb: "#333333"},
                  bold: true,
                  italic: false,
                  underline: false,
                },
                alignment: {
                  horizontal: "left",
                   vertical: "center",
                },
                border: {
                  top: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          }
        }
        else if (j === 22 + lines) {
          if (column[i] === 'A') {
            const topRow = {
              key: column[i] + j,
              value: {
                border: {
                  bottom: {
                    style: "thin",
                    color: {auto: 1}
                  },
                  left: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          } else if (column[i] === 'M') {
            const topRow = {
              key: column[i] + j,
              value: {
                border: {
                  bottom: {
                    style: "thin",
                    color: {auto: 1}
                  },
                  right: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          } else {
            const topRow = {
              key: column[i] + j,
              value: {
                border: {
                  bottom: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          }
        }
        else {
          if (column[i] === 'M') {
            const topRow = {
              key: column[i] + j,
              value: {
                border: {
                  right: {
                    style: "thin",
                    color: {auto: 1}
                  },
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          }else if ( column[i] === 'A'){
            const topRow = {
              key: column[i] + j,
              value: {
                border: {
                  left: {
                    style: "thin",
                    color: {auto: 1}
                  },
                },
                font: {
                  name: "微软雅黑",
                  sz: 9,
                  color: {rgb: "#333333"},
                  bold: true,
                  italic: false,
                  underline: false,
                },
                alignment: {
                  // 唛头格式换行
                  wrapText: (column[i] + j) == 'A19',
                  horizontal: "left",
                  vertical: "center",
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          } else {
            const topRow = {
              key: column[i] + j,
              value: {
                font: {
                  name: "微软雅黑",
                  sz: 9,
                  color: {rgb: "#333333"},
                  bold: true,
                  italic: false,
                  underline: false,
                },
                alignment: {
                  // 唛头格式换行
                  wrapText: (column[i] + j) == 'A19',
                  horizontal: "left",
                  vertical: "center",
                }
              },
            };
            customsDeclarationFormItem.push(topRow);
          }
        }
      }

      for (let j = 23 + lines; j < 23 + lines + this.customsDeclarationSize + 5; j++) {
        if (j >= 23 + lines + this.customsDeclarationSize + 2 ){
          if (j === 23 + lines + this.customsDeclarationSize + 2){
            if (column[i] === 'A' || column[i] === 'K'){
              const itemRow = {
                key: column[i] + j,
                value: {
                  font: {
                    name: "微软雅黑",
                    sz: 9,
                    color: {rgb: "#333333"},
                    bold: true,
                    italic: false,
                    underline: false,
                  },
                  alignment: {
                    horizontal: "left",
                     vertical: "center",
                  },
                  border: {
                    top: {
                      style: "thin",
                      color: {auto: 1}
                    },
                    left: {
                      style: "thin",
                      color: {auto: 1}
                    },
                  }
                },
              };
              customsDeclarationFormItem.push(itemRow);
            }else if (column[i] === 'M'){
              const itemRow = {
                key: column[i] + j,
                value: {
                  border: {
                    top: {
                      style: "thin",
                      color: {auto: 1}
                    },
                    right: {
                      style: "thin",
                      color: {auto: 1}
                    }
                  }
                },
              };
              customsDeclarationFormItem.push(itemRow);
            }
            else{
              const itemRow = {
                key: column[i] + j,
                value: {
                  font: {
                    name: "微软雅黑",
                    sz: 9,
                    color: {rgb: "#333333"},
                    bold: true,
                    italic: false,
                    underline: false,
                  },
                  alignment: {
                    horizontal: "left",
                     vertical: "center",
                  },
                  border: {
                    top: {
                      style: "thin",
                      color: {auto: 1}
                    }
                  }
                },
              };
              customsDeclarationFormItem.push(itemRow);
            }
          }
          else if ( j === 23 + lines + this.customsDeclarationSize + 3 ){
            if (column[i] === 'A' || column[i] === 'K'){
              const itemRow = {
                key: column[i] + j,
                value: {
                  border: {
                    left: {
                      style: "thin",
                      color: {auto: 1}
                    },
                  }
                },
              };
              customsDeclarationFormItem.push(itemRow);
            }else if ( column[i] === 'M'){
              const itemRow = {
                key: column[i] + j,
                value: {
                  border: {
                    right: {
                      style: "thin",
                      color: {auto: 1}
                    },
                  }
                },
              };
              customsDeclarationFormItem.push(itemRow);
            }
          }
          else if(j === 23 + lines + this.customsDeclarationSize + 4){
            if (column[i] === 'A' || column[i] === 'K'){
              const itemRow = {
                key: column[i] + j,
                value: {
                  font: {
                    name: "微软雅黑",
                    sz: 9,
                    color: {rgb: "#333333"},
                    bold: true,
                    italic: false,
                    underline: false,
                  },
                  alignment: {
                    horizontal: "left",
                     vertical: "center",
                  },
                  border: {
                    bottom: {
                      style: "thin",
                      color: {auto: 1}
                    },
                    left: {
                      style: "thin",
                      color: {auto: 1}
                    },
                  }
                },
              };
              customsDeclarationFormItem.push(itemRow);
            }else if (column[i] === 'M'){
              const itemRow = {
                key: column[i] + j,
                value: {
                  border: {
                    bottom: {
                      style: "thin",
                      color: {auto: 1}
                    },
                    right: {
                      style: "thin",
                      color: {auto: 1}
                    }
                  }
                },
              };
              customsDeclarationFormItem.push(itemRow);
            }
            else{
              const itemRow = {
                key: column[i] + j,
                value: {
                  font: {
                    name: "微软雅黑",
                    sz: 9,
                    color: {rgb: "#333333"},
                    bold: true,
                    italic: false,
                    underline: false,
                  },
                  alignment: {
                    horizontal: "left",
                     vertical: "center",
                  },
                  border: {
                    bottom: {
                      style: "thin",
                      color: {auto: 1}
                    }
                  }
                },
              };
              customsDeclarationFormItem.push(itemRow);
            }
          }
        }
        if (j >= 23 + lines && j < 23 + lines + this.customsDeclarationSize + 2){
          const topRow = {
            key: column[i] + j,
            value: {
              font: {
                name: "微软雅黑",
                sz: 9,
                color: {rgb: "#333333"},
                bold: true,
                italic: false,
                underline: false,
              },
              alignment: {
                horizontal: "center",
                 vertical: "center",
              },
              border: {
                top: {
                  style: "thin",
                  color: {auto: 1}
                },
                left: {
                  style: "thin",
                  color: {auto: 1}
                },
                right: {
                  style: "thin",
                  color: {auto: 1}
                },
                bottom: {
                  style: "thin",
                  color: {auto: 1}
                },
              }
            },
          };
          customsDeclarationFormItem.push(topRow);
        }
      }
    }
    return  customsDeclarationFormItem;
  }


  // // 申报要素 style
private styles5 = [];
  private getElementListStyles() {
    const column = ['A','B','C','D'];
    for (let i = 0; i < column.length; i++) {
      for (let j = 1; j <= this.elementListSize + 1; j++) {
        const itemRow = {
          key: column[i] + j,
          value: {
            font: {
              name: "Times New Roman",
              sz: 12,
              color: {rgb: "#333333"},
              bold: false,
              italic: false,
              underline: false,
            },
            alignment: {
              horizontal: "left",
               vertical: "center",
            },
            border: {
              top: {
                style: "thin",
                color: {auto: 1},
              },
              bottom: {
                style: "thin",
                color: {auto: 1},
              },
              left: {
                style: "thin",
                color: {auto: 1}
              },
              right: {
                style: "thin",
                color: {auto: 1}
              }
            }
          },
        };
       this.styles5.push(itemRow);
      }
    }
  }

  // 导出excel
  private isExporting = false;

  private async downloadFiveExcel() {
    if(!this.data_.processStage.canDownloadDeclarationInfo) {
      Message.error({
        message: "此报关合同，财务还未验审，无法下载五件套",
        duration: 2000
      });
      return;
    }
    await this.packingListInfo();
    if (this.packingListData.prompt) {
      this.$confirm(this.packingListData.prompt, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString:true
      }).then(async() => {
        await this.geElementsList();
        await this.salesContractOrInvoiceData();
        this.excelJson1();
        this.excelJson2();
        this.excelJson3();
        this.excelJson4();
        this.isExporting = true;
        //注意：组装的导出excel所需要的数据结构
        const excelDatas = [
          {
            header: this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?["温州华强汽配有限公司"]:["温州嘉锐实业有限公司"],
            filterVal: this.filterVal1,
            tableDatas: this.tableDatas1,
            merges: this.merges1,
            multiHeader: this.multiHeader1,
            styles: this.styles1,
            sheetName: "发票", // 表一的sheet名字
          },
          {
            header: this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?["温州华强汽配有限公司"]:["温州嘉锐实业有限公司"],
            filterVal: this.filterVal2,
            tableDatas: this.tableDatas2,
            merges: this.merges2,
            multiHeader: this.multiHeader2,
            styles: this.styles2,
            sheetName: "箱单",
          },
          {
            header: this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?["温州华强汽配有限公司", "", "", "", "", "", "", ""]:["温州嘉锐实业有限公司", "", "", "", "", "", "", ""],
            filterVal: this.filterVal3,
            tableDatas: this.tableDatas3,
            merges: this.merges3,
            multiHeader: this.multiHeader3,
            styles: this.styles3,
            sheetName: "销售合同",
          },
          {
            header: ["", "", "", "", "", "", "", "", "", "", "", "", ""],
            filterVal: this.filterVal4,
            tableDatas: this.tableDatas4,
            merges: this.merges4,
            multiHeader: this.multiHeader4,
            styles: this.styles4,
            sheetName: "报关单",
          },
          {
            header: [
              "S/N",
              "报关品名",
              "HS编码",
              "申报要素",
            ],
            filterVal: [
              "index",
              "customsProductName",
              "hsCode",
              "remark",
            ],
            tableDatas: this.elementsList,
            merges: [],
            multiHeader: [],
            styles: this.styles5,
            sheetName: "申报要素",
          },
        ];
        //   引入的函数
        this.json2excel(excelDatas,"五件套");
        this.isExporting = false;
      })
    } else {
      await this.geElementsList();
      await this.salesContractOrInvoiceData();
      this.excelJson1();
      this.excelJson2();
      this.excelJson3();
      this.excelJson4();
      this.isExporting = true;
      //注意：组装的导出excel所需要的数据结构
      const excelDatas = [
        {
          header: this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?["温州华强汽配有限公司"]:["温州嘉锐实业有限公司"],
          // header: ["温州华强汽配有限公司"],
          filterVal: this.filterVal1,
          tableDatas: this.tableDatas1,
          merges: this.merges1,
          multiHeader: this.multiHeader1,
          styles: this.styles1,
          sheetName: "发票", // 表一的sheet名字
        },
        {
          header: this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?["温州华强汽配有限公司"]:["温州嘉锐实业有限公司"],
          // header: ["温州华强汽配有限公司"],
          filterVal: this.filterVal2,
          tableDatas: this.tableDatas2,
          merges: this.merges2,
          multiHeader: this.multiHeader2,
          styles: this.styles2,
          sheetName: "箱单",
        },
        {
          header: this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?["温州华强汽配有限公司", "", "", "", "", "", "", ""]:["温州嘉锐实业有限公司", "", "", "", "", "", "", ""],
          // header: ["温州华强汽配有限公司", "", "", "", "", "", "", ""],
          filterVal: this.filterVal3,
          tableDatas: this.tableDatas3,
          merges: this.merges3,
          multiHeader: this.multiHeader3,
          styles: this.styles3,
          sheetName: "销售合同",
        },
        {
          header: ["", "", "", "", "", "", "", "", "", "", "", "", ""],
          filterVal: this.filterVal4,
          tableDatas: this.tableDatas4,
          merges: this.merges4,
          multiHeader: this.multiHeader4,
          styles: this.styles4,
          sheetName: "报关单",
        },
        {
          header: [
            "S/N",
            "报关品名",
            "HS编码",
            "申报要素",
          ],
          filterVal: [
            "index",
            "customsProductName",
            "hsCode",
            "remark",
          ],
          tableDatas: this.elementsList,
          merges: [],
          multiHeader: [],
          styles: this.styles5,
          sheetName: "申报要素",
        },
      ];
      //   引入的函数
      this.json2excel(excelDatas, "五件套");
      this.isExporting = false;
    }

  }
  private async downloadPackingListExcel() {
    await this.packingListInfo();
    if (this.packingListData.prompt) {
      this.$confirm(this.packingListData.prompt, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString:true
      }).then(async() => {
        this.excelJson2();
        this.isExporting = true;
        //注意：组装的导出excel所需要的数据结构
        const excelDatas = [
          {
            header: this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?["温州华强汽配有限公司"]:["温州嘉锐实业有限公司"],
            filterVal: this.filterVal2,
            tableDatas: this.tableDatas2,
            merges: this.merges2,
            multiHeader: this.multiHeader2,
            styles: this.styles2,
            sheetName: "箱单",
          }
        ];
        //   引入的函数
        this.json2excel(excelDatas,"箱单");
        this.isExporting = false;
      })
    } else {
      this.excelJson2();
      this.isExporting = true;
      //注意：组装的导出excel所需要的数据结构
      const excelDatas = [
        {
          header: this.data_.bookingOrderCode.split("").length > 0 && this.data_.bookingOrderCode.split("")[0] === 'B'?["温州华强汽配有限公司"]:["温州嘉锐实业有限公司"],
          // header: ["温州华强汽配有限公司"],
          filterVal: this.filterVal2,
          tableDatas: this.tableDatas2,
          merges: this.merges2,
          multiHeader: this.multiHeader2,
          styles: this.styles2,
          sheetName: "箱单",
        },
      ];
      //   引入的函数
      this.json2excel(excelDatas,"箱单");
      this.isExporting = false;
    }

  }

  // tableJson 导出数据 ;
  private json2excel(tableJson, name) {
    const filename = `报关资料（` + name + `）`;
    //这个是引用插件
    import("@/utils/excel").then((excel) => {
      const header = [];
      const data = [];
      const sheetname = [];
      const merges = [];
      const styles = [];
      const multiHeader = [];
      for (let i in tableJson) {
        header.push(tableJson[i].header);
        data.push(formatJson(tableJson[i].filterVal, tableJson[i].tableDatas));
        sheetname.push(tableJson[i].sheetName);
        merges.push(tableJson[i].merges);
        multiHeader.push(tableJson[i].multiHeader);
        styles.push(tableJson[i].styles);
      }
      excel.exportJson3Excel(
          header,
          data,
          sheetname,
          filename,
          multiHeader,
          merges,
          true,
          styles
      );
    });
  }

  private internationalTradeTermsOptions = [
    { label: "FOB", value: "1" },
    { label: "CIF", value: "2" },
    { label: "C&F", value: "3" },
    { label: "DPU", value: "4" }
  ];
}

export class LoadingPlanListTableRowData {
  id: string;
  code: string;
  createdDate: string;
  containerType: string;
  type: LoadingPlanType;
  category: string;
  loadingPlace: string;
  containerInfo: string;
  totalProductQuantity: number;
  totalAmount: string;
  totalVolume: string;
  select: boolean;

  isMatch(code?: string, category?: string, factoryName?: string): boolean {
    let match = true;
    if (!isEmpty(code)) {
      match = this.code.includes(toUpper(code));
    }
    if (!isEmpty(category)) {
      match = match && this.category === category;
    }
    if (!isEmpty(factoryName)) {
      match = match && this.loadingPlace.includes(factoryName);
    }
    return match;
  }
}
